<template>
    <div class="base-input">
        <label :for="inputName" class="base__label container--row">
            <p class="base__label-title">
                {{ title }}
            </p>
            <div
                @click="showPopUp"
                @mouseover="showImage"
                @mouseleave="showImage"
                class="base__label-info"
            >
                {{ info }}
            </div>
            <div class="base__label-image">
                <img
                    alt="postfix image"
                    v-if="postfixLabelImage && active"
                    :src="require('@/assets/icons/' + postfixLabelImage)"
                    class=""
                    loading="lazy" 
                    decoding="async"
                />
            </div>
        </label>
        <div class="base__input-wrapper" :class="{ 'is-invalid': !!errorMessage }">
            <img
                :src="require('@/assets/icons/' + newPrefixedImage + '.svg')"
                class="base__input-prefix"
                alt="prefix image"
                loading="lazy" 
                decoding="async"
            />
            <!-- @paste="formatPaste($event)" -->
            <input
                name="primary"
                :id="inputName"
                @keypress="formatText($event)"
                @paste="formatText($event)"
                @input="formatText($event)"
                @change="formatText($event)"
                :type="type"
                @focus="handleFocus"
                @focusin="handleFocusIn"
                @blur="handleBlur"
                ref="inputfield"
                :aria-label="title"
                :maxlength="totalCharacters"
                v-model="inputValue"
                min="0"
                :required="isRequired"
                :placeholder="title === 'PHONE NUMBER' && state.currency !== 'XOF' ? defaultPlaceholderForPhoneNumber : placeholder"
                :inputmode="inputMode"
                autocomplete="off"
            />
            <div class="card__provider" v-if="postfixImage">
                <svg
                    v-if="postfixImage"
                    width="7"
                    height="9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.326 3.112h-.442v-.677C5.884 1.092 4.73 0 3.338 0S.792 1.092.792 2.435v.677H.385c-.227 0-.385.273-.385.491V7.72c0 .218.158.306.385.306h5.952c.226 0 .35-.088.35-.306V3.603c-.01-.218-.146-.491-.361-.491zm-3.53 3.494l.18-1.005a.565.565 0 01-.26-.47c0-.338.283-.61.634-.61.35 0 .633.272.633.61 0 .208-.101.35-.26.46l.181 1.015H2.795zM1.47 2.435v.677h3.735v-.677c0-.994-.85-1.79-1.868-1.79-1.018 0-1.867.807-1.867 1.79z"
                        fill="#4F4F4F"
                    />
                </svg>
                <img
                    v-if="postfixImage && image != ''"
                    :src="require(`@/assets/icons/${image}`)"
                    ref="card"
                    alt="postfix image"
                    class="base__input-suffix"
                    loading="lazy" 
                    decoding="async"
                />
            </div>
        </div>
        <p v-if="errorMessage" class="base__error mg" role="alert">
            <svg class="base__error-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="8" fill="#EB5757" />
                <path d="M8 4.6v.02" stroke="#fff" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 7.1v4.3" stroke="#fff" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>{{ errorMessage }}</span>
        </p>
    </div>
</template>
<script>
import { onBeforeUnmount, ref, computed, watch, onMounted } from "vue";
import { getValueFromPath } from "@/support/helpers";
import { formatPan } from "@/support/card-number";
import { mapState, injectStore } from "redux-vuex";
import defaultPhonePlaceholders from "../../default-phone-numbers";


export default {
    name: "PrimaryInput",
    emits: ["value-change", "show-modal", "completed-date", "new-focus", "blur"],
    props: {
        //switch to inheritAttr
        prefixImage: {
            type: String,
            default: "",
            required: true,
        },
        defaultValue: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
            required: true,
        },
        postfixImage: {
            type: Boolean,
            default: false,
        },
        numberOnly: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "text",
        },
        card: {
            type: Boolean,
            default: false,
        },
        date: {
            type: Boolean,
            default: false,
        },
        totalCharacters: {
            type: Number,
            required: false,
        },
        isRequired: {
            type: Boolean,
            required: true,
        },
        inputName: {
            type: String,
            required: true,
        },
        inputMode: {
            type: String,
        },
        title: {
            type: String,
            required: true,
        },
        info: {
            type: String,
            default: "",
        },
        postfixLabelImage: {
            type: String,
            required: false,
        },
        modalOpen: {
            type: Boolean,
        },
        focused: {
            type: String,
        },
        cardname:  {
            type: Boolean,
            default: false,
        },
        isVoucher: {
            type: Boolean,
            default: false,
        },
        numberAlphabet:  {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: "",
        },
    },
    watch: {
        defaultValue: function(newVal) {
            this.inputValue = newVal;
            if (this.card && this.inputValue !== null) {
                this.formatCard();
            }
        },
        focused: function(newVal) {
            newVal == this.inputName ? this.inputfield.focus() : "";
        },
    },
    mounted() {
        this.focused == this.inputName ? this.inputfield.focus() : "";
        this.inputValue = this.defaultValue;
    },
    methods: {
        formatText(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (this.numberOnly) {
                if (evt.type == "keypress") {
                    this.restrictToAlphabet(charCode, evt);
                }
                if (evt.type == "paste") {
                    if (evt.clipboardData) {
                        const copiedText = evt.clipboardData.getData("text/plain");
                        if ( ( /^[\d +]+$/.test(copiedText) ) ) {
                            return true;
                        } 
                        else {
                            evt.preventDefault();
                            return false;
                        }
                    }
                }
                if (this.card) {
                    this.formatCard(charCode, evt);
                    if (evt.clipboardData) {
                        const newVal = evt.clipboardData.getData("text/plain");
                        this.$emit("value-change", newVal);
                    }
                }
                if (this.date) {
                    this.formatValidTill(charCode, evt);
                }
                if (this.inputValue && this.inputValue.length > this.characterLimit) {
                    this.inputValue = this.inputValue.slice(0, this.characterLimit);
                }
            }

            if (this.cardname) {
                if (evt.type == "keypress") {
                    this.validateCardholderName(charCode, evt);
                }
                if (evt.clipboardData) {
                    const newVal = evt.clipboardData.getData("text/plain");
                    this.validateCardholderName(newVal, evt);
                    this.$emit("value-change", newVal);
                }
            }
            if (this.numberAlphabet) {
                if (evt.type == "keypress") {
                    this.restrictNumberAlphabet(charCode, evt);
                }
                if (evt.clipboardData) {
                    const newVal = evt.clipboardData.getData("text/plain");
                    this.restrictNumberAlphabet(newVal, evt);
                    this.$emit("value-change", newVal);
                }
            }
            if (this.isVoucher) {
                if (evt.type == "keypress") {
                    this.validateVoucherPin(charCode, evt);
                }
                if (evt.type == "paste") {
                    if (evt.clipboardData) {
                        const copiedText = evt.clipboardData.getData("text/plain");
                        if ( ( /^[\d\s-]+$/.test(copiedText) ) ) {
                            return true;
                        } 
                        else {
                            evt.preventDefault();
                            return false;
                        }
                    }
                }
            }
        },
        handleFocusIn() {
            this.$emit("new-focus", this.inputName);
        },
        formatValidTill(charCode, evt) {
            this.formatExpiry(evt);
        },
        showImage: function() {
            if (!this.adaptStateToDevice()) {
                return;
            }
            else {
                this.active = !this.active;
            }
        },
        showPopUp: function() {
            if (!this.adaptStateToDevice()) {
                if (!this.modalOpen) {
                    this.popup = true;
                    this.$emit("show-modal", this.popup);
                }
            }
            else {
                return;
            }
        },
    },
    setup(props, { emit }) {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const inputfield = ref({});
        const isFocused = ref(false);
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        const inputValue = ref("");
        const active = ref(false);
        const popup = ref(false);
        const image = ref("");

        watch(inputValue, (newVal) => {
            emit("value-change", newVal);
            // No auto-advance off the card number field: PANs run 15-19 digits and
            // nothing observable at the 16th digit reliably means "the user is done",
            // so any trigger here steals focus mid-entry on longer cards.
            if (newVal && newVal.length == props.totalCharacters && props.date) {
                emit("completed-date");
            }

            if(newVal && newVal.length > 2 && !newVal.includes("/") && props.date) {
                inputValue.value = newVal.slice(0, 2) + "/" + newVal.slice(2);
            }
        });
        watch(() => checkoutData.value, (newData, oldData) => {
            if (newData.view.context.cardType !== oldData.view.context.cardType) {
                formatCard();
            }
        });
        function handleFocus() {
            isFocused.value = true;
            const data = {
                name: props.inputName,
                label: `${props.title}`,
                value: inputfield.value.value,
            };
            checkoutData.value.view.context.$actions.focusin(data);
        }
        function handleBlur() {
            isFocused.value = false;
            const data = {
                name: props.inputName,
                label: `${props.title}`,
                value: inputfield.value ? inputfield.value.value : {},
            };
            const focusout = getValueFromPath(checkoutData.value, "view.context.$actions.focusout");
            if (typeof focusout === "function") {
                focusout(data);
            }
            emit("blur", props.inputName);
        }
        function formatCard() {
            switch (checkoutData.value.view.context.cardType) {
            case "VISA":
                image.value = "new-visa.svg";
                break;
            case "MASTERCARD":
                image.value = "mastercard.svg";
                break;
            case "AMEX":
                image.value = "amex.svg";
                break;
            case "AMERICAN":
                image.value = "amex.svg";
                break;
            case "DISCOVER":
                image.value = "discover.svg";
                break;
            case "MAESTRO":
                image.value = "verve.svg";
                break;
            case "AFRIGO":
                image.value = "afrigo.svg";
                break;
            default:
                image.value = "othercard.svg";
                break;
            }
            
            if (inputValue.value) {
                inputValue.value = formatPan(inputValue.value);
            }

        }
        function formatDate() {
            inputValue.value = inputValue.value.replace(/[^0-9\-/]/g, "");
        }

        const newPrefixedImage = computed(() => {
            let logo = "";
            if (isFocused.value) {
                logo = `${props.prefixImage}-light`;
            }
            else {
                logo = props.prefixImage;
            }
            return logo;
        });

        /**
         * Makeshift solution for the dynamic placeholder task (WIP)
         * mobile-money-franco component is excluded (when XOF is current currency) 
         * because of the several countries available for Momo
         * and inability to get the exact country selected on the select component
         * 
         * Once a country isn't selected from the dropdown, the placeholder value will be blank
         */
        const defaultPlaceholderForPhoneNumber = computed(() => {
            let currency = checkoutData.value.currency.current;
            let placeholder;

            Object.entries(defaultPhonePlaceholders).forEach(([key, value]) => {
                if (key.includes(currency)) {
                    placeholder = value;
                } 
            });

            if(!placeholder){
                placeholder = props.placeholder;
            }
            
            return placeholder;
        });

        const characterLimit = computed(() => props.totalCharacters);

        onMounted(() => {
            if (props.card && inputValue.value !== null) {
                formatCard();
            }
        });

        onBeforeUnmount(() => {
            subscription();
        });
        return {
            defaultPlaceholderForPhoneNumber,
            state: mapState({
                context: (state) => getValueFromPath(state, "view.context") || {},
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
            }),
            inputfield,
            newPrefixedImage,
            handleBlur,
            handleFocus,
            inputValue,
            formatCard,
            formatDate,
            characterLimit,
            popup,
            active,
            image,
        };
    },
};
</script>

<style lang="scss" scoped>
// .base__input-wrapper {
//     margin-bottom: -0.1rem;
// }

.base__input-wrapper.is-invalid {
    border-color: #eb5757;
}

.base__error {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 1.2rem 1.4rem;
    background: #FDECEC;
    border-radius: 0.6rem;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #eb5757;
}

.mg {
    margin-top: -3rem;
}

.base__error-icon {
    flex-shrink: 0;
}
</style>